import 'slick-carousel'

const SLIDER = '.js-slider',
      SLIDER_ITEM = '.js-slider-item',
      SLIDER_PAGING = '.js-slide-paging',
      SLIDER_PREV = '.js-slide-prev',
      SLIDER_NEXT = '.js-slide-next',
      SLIDER_THUMB = '.js-slide-thumb',
      SLIDER_DOTS = '.js-slide-dots',
      SLIDER_FADE = '.js-slide-fade',
      SLIDER_THUMB_FADE = '.js-slide-fade-thumb',
      SLIDER_AUTO = '.js-slide-auto',
      SLIDER_DATA_NUM = 'data-num',
      SLIDER_DATA_SP_NUM = 'data-sp-num',
      SLIDER_DATA_THUMB_NUM = 'data-thumb-num',
      SLIDER_DATA_THUMB_SP_NUM = 'data-thumb-sp-num',
      SLIDER_DATA_TO_SCROLL = 'data-to-scroll',
      SLIDER_DATA_TO_SP_SCROLL = 'data-to-sp-scroll',
      SLIDER_DATA_SPEED = 'data-speed',
      SLIDER_DATA_CENTER = 'data-center'

/**
 * Slick slider
 * @export
 * @class Slider
 */
export default class Slider {

  constructor() {
    this.init()
  }

  init(el) {
    this.slide()
  }

  slide(el) {
    $(function () {
      el = $(SLIDER)
      el.each((index, element) => {
        const $this = $(element)
        const $slideElm = $this.find(SLIDER_ITEM),
              slideNum = $this.attr(SLIDER_DATA_NUM),
              slideNumSp = $this.attr(SLIDER_DATA_SP_NUM),
              slideNumThumb = $this.attr(SLIDER_DATA_THUMB_NUM),
              slideNumThumbSp = $this.attr(SLIDER_DATA_THUMB_SP_NUM),
              slideNumThumbSpOn = slideNumThumbSp !== undefined ? slideNumThumbSp : slideNumThumb,
              slideToScroll = $this.attr(SLIDER_DATA_TO_SCROLL),
              slideToScrollNum = Number(slideToScroll),
              slideToSpScroll = $this.attr(SLIDER_DATA_TO_SP_SCROLL),
              slideToSpScrollNum = Number(slideToSpScroll),
              slideSpeed = $this.attr(SLIDER_DATA_SPEED),
              slideCenter = $this.attr(SLIDER_DATA_CENTER),
              slideCenterOn = slideCenter !== undefined ? true : false,
              $slidePaging = $this.find(SLIDER_PAGING),
              $slidePrev = $this.find(SLIDER_PREV),
              $slideNext = $this.find(SLIDER_NEXT),
              $slideDots = $this.find(SLIDER_DOTS),
              $slideThumb = $this.find(SLIDER_THUMB),
              slideThumbOn = $slideThumb.length ? $slideThumb : false,
              $slideFade = $this.find(SLIDER_FADE),
              slideFadeOn = $slideFade.length ? true : false,
              $slideThumbFade = $this.find(SLIDER_THUMB_FADE),
              slideThumbFadeOn = $slideThumbFade.length ? true : false,
              $slideAuto = $this.find(SLIDER_AUTO),
              slideAutoOn = $slideAuto.length ? true : false

        $slideElm.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
          $(e.delegateTarget).find('.js-animate').removeClass('u-transparent animated')
        })

        $slideElm.slick({
          autoplay: slideAutoOn,
          autoplaySpeed: 5000,
          dots: true,
          appendDots: $slideDots,
          fade: slideFadeOn,
          slidesToShow: slideNum,
          slidesToScroll: slideToScrollNum,
          speed: slideSpeed,
          infinite: true,
          nextArrow: $slideNext,
          prevArrow: $slidePrev,
          asNavFor: slideThumbOn,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          responsive: [
            {
              breakpoint: 834,
              settings: {
                slidesToScroll: 1,
                slidesToShow: slideNumSp
              }
            }
          ]
        })

        if ($slideThumb.length) {
          $slideThumb.slick({
            arrows: false,
            fade: slideThumbFadeOn,
            centerMode: true,
            dots: false,
            slidesToScroll: 1,
            centerMode: slideCenterOn,
            slidesToShow: slideNumThumb,
            asNavFor: $slideElm,
            focusOnSelect: true,
            responsive: [
              {
                breakpoint: 834,
                settings: {
                  slidesToScroll: slideToSpScrollNum,
                  slidesToShow: slideNumThumbSpOn
                }
              }
            ]
          })
        }
      })
    })
  }
}